module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-starts-1-large-f6befcaac70f6acdc7b808a61245149e.jpg";